var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"moveTarget",staticClass:"drag-target",style:(_vm.style),attrs:{"data-transform-key":_vm.mykey}},[_c('div',{style:(_vm.style2)},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }